export const token = JSON.parse(localStorage.getItem("token")) || null;
export const adminInfo = JSON.parse(localStorage.getItem("admin")) || null;

const dataLocalStorage = {
    token: token,
    adminInfo: adminInfo,
};

export default dataLocalStorage;
